export default __webpack_public_path__ + "static/media/zenstrin-logo-white.389c0a27.png";